import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import CritiquePanel from "@/components/CritiquePanel";
import { PageContainer } from "@/components/PageContainer";

export const Route = createFileRoute("/critique")({
  component: CritiquePage,
  head: () => ({
    meta: [
      { title: "Critique a draft — Tiger's Eye" },
      {
        name: "description",
        content:
          "Paste a paragraph and get integrity-aware, knowledge-graph-grounded critique from Tiger's Eye.",
      },
    ],
  }),
});

function CritiquePage() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-background">
        <PageContainer>
          <CritiquePanel />
        </PageContainer>
      </main>
      <Footer />
    </>
  );
}
